import { openDB } from 'idb'
import { IDB_STORES, LOCALSTORAGE_KEYS_IDB_STORE_LAST_UPDATED } from 'src/consumer/constants'

const requiredStores = Object.values(IDB_STORES).map((store) => store.name)

export async function createERMDatabase() {
  // v11: records are now encrypted at rest (see idbCrypto.js) and the drug-advice
  // entity stores were added — the upgrade wipes all stores, which also removes any
  // plaintext data written by older versions; stores repopulate via the EMR sync.
  const dbPromise = openDB('erm-database', 11, {
    blocked() {
      console.warn(
        'erm-database upgrade is blocked by another open tab still running an older app version — it will proceed once that tab closes or reloads',
      )
    },
    blocking() {
      // a newer version wants to upgrade in another tab — close this connection so
      // the upgrade can proceed; our operations open fresh connections anyway
      dbPromise.then((db) => db.close()).catch(() => {})
    },
    upgrade(db, oldVersion) {
      // delete the stores that are not supported
      // const existingStores = Array.from(db.objectStoreNames)
      // for (const store of existingStores) {
      //   if (!requiredStores.includes(store)) {
      //     db.deleteObjectStore(store) // Remove unwanted stores
      //   }
      // }

      // Delete all existing object stores (wipe IndexedDB)
      const existingStores = Array.from(db.objectStoreNames)
      for (const store of existingStores) {
        db.deleteObjectStore(store)
      }

      for (const storeConfig of Object.values(IDB_STORES)) {
        const { name, keyPath, indexes } = storeConfig
        let store
        if (!db.objectStoreNames.contains(name)) {
          store = db.createObjectStore(name, { keyPath })
          for (const { name: indexName, field, unique } of indexes) {
            store.createIndex(indexName, field, { unique })
          }
        }
      }

      // Delete specific Local Storage values
      Object.values(LOCALSTORAGE_KEYS_IDB_STORE_LAST_UPDATED).forEach(key => localStorage.removeItem(key));
    },
  })
  return dbPromise
}

// NOT BEING USED
export async function deleteERMDatabase() {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.deleteDatabase('erm-database')

    request.onsuccess = () => {
      console.log(`Database ${'erm-database'} deleted successfully`)
      resolve()
    }

    request.onerror = (event) => {
      console.error(`Error deleting database ${'erm-database'}:`, event.target.error)
      reject(event.target.error)
    }

    request.onblocked = () => {
      console.warn(`Database ${'erm-database'} deletion blocked`)
    }
  })
}
